{
  "subsDetails": {
    "App Designer enables you to create real-time applications without having to code.": "El App Designer le permite crear aplicaciones en tiempo real sin necesidad de programar.",
    "Create visual, model-driven data flows that combine Event Stream Processing with ETL and data contextualization.": "Cree flujos de datos visuales basados en modelos que combinan Procesamiento de Flujos de Eventos con ETL y contextualización de datos.",
    "XMPro AI Designer Product for Jupyter Hub Authentication": "Producto XMPro AI Designer para autenticación de Jupyter Hub"
  },
  "appcenter": {
    "Active": "Activo",
    "Error": "Error",
    "Draft": "Borrador"
  }
}
